<template>
  <div id="table-product">
    <table-component :dataColumn="dataColumn">
      <template v-slot:header>
        <table-header :title="'ID'" :minWidth="50" />
        <table-header :title="$t('product.category')" :minWidth="150" />
        <table-header :title="$t('product.subcategory')" :minWidth="150" />
        <table-header :title="$t('product.status')" :minWidth="120" />
        <table-header :title="$t('product.place')" :minWidth="100" />
        <table-header :title="$t('product.marker')" :minWidth="150" />
        <table-header :title="$t('product.productName')" :minWidth="220" />
        <table-header :title="$t('product.modelNumber')" :minWidth="120" />
        <table-header :title="$t('product.years')" :minWidth="80" />
        <table-header :title="$t('product.conditionType')" :minWidth="80" />
        <table-header :title="$t('product.purchasePrice')" :minWidth="150" />
        <table-header :title="$t('product.price')" :minWidth="150" />
        <table-header :title="$t('product.quantity')" :minWidth="80" />
        <table-header :title="$t('product.totalPurchase')" :minWidth="150" />
        <table-header :title="$t('product.note')" :minWidth="200" />
        <table-header :title="$t('product.store')" :minWidth="120" />
        <table-header :title="$t('product.manager')" :minWidth="120" />
        <table-header :title="$t('product.date')" :minWidth="120" />
        <table-header
          fixed="right"
          :title="$t('common.action')"
          :minWidth="80"
        />
      </template>

      <template class="product-table" v-slot:body="{ rowData: row, index }">
        <table-cell>{{ index + 1 + (currentPage - 1) * LIMIT }}</table-cell>
        <table-cell>{{ row.subcategory.category.name }}</table-cell>
        <table-cell>{{ row.subcategory.name }}</table-cell>
        <table-cell>{{ EStatusProduct.getTitle(row.status) }}</table-cell>
        <table-cell>{{ EPlaceTypeProduct.getTitle(row.placeType) }}</table-cell>
        <table-cell> {{ row.marker }} </table-cell>
        <table-cell>{{ row.name }}</table-cell>
        <table-cell>{{ row.modelNumber }}</table-cell>
        <table-cell> {{ row.yearOfManufacture }} </table-cell>
        <table-cell>
          {{ EConditionTypeProduct.getTitle(row.conditionType) }}
        </table-cell>
        <table-cell>
          {{ formatNumber(row.buyPrice) }}{{ $t('common.yen') }}
        </table-cell>
        <table-cell>
          {{ formatNumber(row.sellPrice) }}{{ $t('common.yen') }}
        </table-cell>
        <table-cell>
          {{ formatNumber(row.quantity) }}
        </table-cell>
        <table-cell>
          {{ formatNumber(row.quantity * row.buyPrice) }}
          {{ $t('common.yen') }}
        </table-cell>
        <table-cell> {{ row.note }} </table-cell>
        <table-cell> {{ row.store.name }} </table-cell>
        <table-cell> {{ row.employee.name }} </table-cell>
        <table-cell> {{ row.date }} </table-cell>

        <table-cell fixed="right">
          <i class="el-icon-edit icon" @click="handleOpenEditDialog(row.id)" />
          <i
            class="el-icon-delete icon"
            @click="handleOpenDeleteDialog(row.id)"
          />
        </table-cell>
      </template>
    </table-component>

    <modal-edit
      :productId="productIdSelected"
      :openEditDialog="openEditDialog"
      @handleCloseEditDialog="handleCloseEditDialog"
    />

    <modal-delete
      :title="null"
      :content="$t('product.deleteTitle')"
      :openDeleteDialog="openDeleteDialog"
      :deleteLoading="deleteProductLoading"
      @handleCloseDialog="handleCloseDeleteDialog"
      @handleConfirm="handleDeleteProduct"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import {
  EConditionTypeProduct,
  EStatusProduct,
  EPlaceTypeProduct,
} from '@/enums/product';
import { productService } from '@/services/product.service';
import { LIMIT, PAGE } from '@/constants/common';
import {
  handleError,
  notifyMessage,
  formatNumber,
  redirectRouter,
} from '@/helper';
import * as pageRouter from '@/constants/pageRouter';

const ModalDelete = () => import('@/components/Dialog/DialogConfirm.vue');
const ModalEdit = () => import('../EditProductDialog');

export default {
  name: 'TableListProduct',
  components: { ModalDelete, ModalEdit },
  props: {
    dataColumn: Array,
    currentPage: Number,
  },
  data() {
    return {
      openDeleteDialog: false,
      openEditDialog: false,
      deleteProductLoading: false,
      productIdSelected: null,
      EConditionTypeProduct,
      EStatusProduct,
      EPlaceTypeProduct,
      LIMIT,
    };
  },
  computed: {
    ...mapGetters('product', ['product']),
  },
  methods: {
    ...mapActions('product', ['getProductList', 'getProductStatistic']),
    formatNumber,
    handleOpenDeleteDialog(productId) {
      this.productIdSelected = productId;
      this.openDeleteDialog = true;
    },
    handleCloseDeleteDialog() {
      this.openDeleteDialog = false;
    },

    handleOpenEditDialog(productId) {
      this.productIdSelected = productId;
      this.openEditDialog = true;
    },

    handleCloseEditDialog() {
      this.productIdSelected = null;
      this.openEditDialog = false;
    },
    async handleDeleteProduct() {
      this.deleteProductLoading = true;

      await productService
        .delete(this.productIdSelected)
        .then(async () => {
          const productLength = this.product.data.length - 1;

          await this.getProductList({
            ...this.$router.currentRoute.query,
            page:
              productLength === 0 && +this.$route.query.page > 1
                ? +this.$route.query.page - 1
                : this.$route.query.page || PAGE,
            limit: LIMIT,
          });

          this.getProductStatistic({
            params: {
              ...this.$route.query,
              page: undefined,
              limit: undefined,
            },
          });
          redirectRouter({
            path: pageRouter.PRODUCT,
            query: {
              ...this.$route.query,
              page:
                productLength === 0 && +this.$route.query.page > 1
                  ? +this.$route.query.page - 1
                  : this.$route.query.page,
            },
          });
          notifyMessage(this.$t('common.deleteSuccess'), 'success');
          this.openDeleteDialog = false;
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          this.deleteProductLoading = false;
        });
    },
  },
};
</script>
